import React from 'react'
import { CLASSES, COLORS } from '../../../assets/styles/classes'
import Table from '../../../components/table/Table'
import { useNavigate } from 'react-router-dom'
import ReactstrapInput from '../../../components/form/input-fields/ReactstrapInput'

export default function BillingDetailsCreate({
  isEditMode = false,
  fields,
  control,
  watch,
  errors,
}) {
  const navigate = useNavigate()
  const columns = [
    {
      name: 'Service',
      style: {
        fontWeight: 'bold',
      },
      cell: ({ title, asset_name }) => title || asset_name || 'Item Name',
      conditionalCellStyles: [
        {
          when: (row) => {
            return row.title === 'Subtotal'
          },
          style: {
            color: COLORS.orange,
          },
        },
        {
          when: (row) => {
            return row.title === 'Total Due'
          },
          style: {
            color: COLORS.orange,
          },
        },
      ],
    },
    {
      name: 'Qty',
      width: '180px',
      style: {
        position: 'relative',
        padding: 0,
        fontWeight: 'normal',
      },
      cell: ({ title, asset_qty, quantity }, i) =>
        quantity ? (
          <div style={{ position: 'absolute', top: -15 }}>
            <ReactstrapInput
              control={control}
              name={`assets.${i}.quantity`}
              placeholder={'Enter Quantity'}
              type='number'
              // showError={false}
              errorMessage={errors?.assets?.[i]?.quantity?.message}
              defaultValue={1}
              xxl='12'
              xl='12'
              lg='12'
              style={{ height: 30 }}
              disabled={watch('is_status_closed')}
            />
          </div>
        ) : (
          ''
        ),
    },
    {
      name: 'Rate',
      minWidth: '180px',
      center: true,
      cell: ({ title, asset_price }) => asset_price,
    },
    {
      name: 'Guarantee',
      minWidth: '180px',
      cell: ({ title, asset_warranty_period }) => asset_warranty_period,
    },
    {
      name: 'Line total',
      minWidth: '180px',
      cell: ({ amount, asset_price, asset_qty, title }, i) => {
        if (title === 'Discount') {
          return (
            <ReactstrapInput
              control={control}
              name='discount'
              type='number'
              showError={false}
            />
          )
        }
        if (title === 'Service Charge') {
          return (
            <ReactstrapInput
              control={control}
              name='serviceCharge'
              type='number'
              showError={false}
            />
          )
        }
        if (title === 'Tax (5%)') {
          return `$${Number(amount).toFixed(2)}`
        }
        if (title === 'Total Due') {
          return amount
        } else {
          return (
            amount ||
            `$${(
              Number(asset_price) * (watch(`assets.${i}.quantity`) || 0)
            ).toFixed(2)}`
          )
        }
      },
      conditionalCellStyles: [
        {
          when: (row) => {
            return row.title === 'Total Due'
          },
          style: {
            color: COLORS.orange,
          },
        },
      ],
    },
  ]

  const conditionalRowStyles = [
    {
      when: (row) => {
        return row.title === 'Subtotal'
      },
      style: {
        borderTop: `1px solid #C8C8C8`,
      },
    },
    {
      when: (row) => {
        return row.title === 'Total Due'
      },
      style: {
        borderTop: `1px solid #C8C8C8`,
      },
    },
  ]

  const data = React.useMemo(() => {
    const subTotal = fields.reduce(
      (acc, curr, i) =>
        acc + Number(curr?.asset_price) * (watch(`assets.${i}.quantity`) || 1),
      0,
    )
    let total_due =
      subTotal +
      subTotal * 0.05 +
      Number(watch('serviceCharge')) -
      Number(watch('discount'))
    return [
      ...fields,
      { title: 'Subtotal', amount: `$${subTotal.toFixed(2) || 0}` },
      { title: 'Discount', amount: watch('discount') },
      { title: 'Service Charge', amount: watch('serviceCharge') },
      { title: 'Tax (5%)', amount: subTotal * 0.05 || 0 },
      { title: 'Total Due', amount: `$${total_due.toFixed(2) || 0}` },
    ]
  }, [
    watch('discount'),
    watch('serviceCharge'),
    fields.length,
    ...[fields.map((item, i) => watch(`assets.${i}.quantity`))],
  ])

  return (
    <div className='mt-5'>
      <div className={CLASSES.content_between}>
        <h4 className={CLASSES.items_center}>Billing Details</h4>
      </div>

      <div className='mb-5 mt-3 border-radius-10 black-shadow-15'>
        <Table
          columns={columns}
          data={data}
          pagination={false}
          customStyle={{
            rows: {
              style: {
                borderTop: '0px solid #E0E0E0',
                borderBottom: '0px solid #E0E0E0 !important',
                display: 'flex !important',
                alignItems: 'center !important',
                padding: 15,
              },
            },
          }}
          conditionalRowStyles={conditionalRowStyles}
        />
      </div>
    </div>
  )
}
